import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { InputMoneyProps } from '../../../../../../../components/InputMoney';
import { AssetSelectedTypeMap } from '../../../../../../../store/product/types';
import { useCoeAddedProductItem } from '../../../../../hooks';
import {
  AddedProductItemList,
  AddedProductItemRouteParamTypeProps,
  AssetWithErrorResponse,
} from '../../../../../utils/types';
import { AddedProductItemContainer } from '../Container';

import { AddedProductItemCoesDesktop } from './desktop';
import { AddedProductItemCoesMobile } from './mobile';
import { AddedProductItemCoesSkeleton } from './skeleton';
import { AddedProductItemCoesTablet } from './tablet';

type CoesData = AssetSelectedTypeMap['coes'] & AssetWithErrorResponse;
export interface AddedProductItemCoesProps {
  data: CoesData;
  type: AddedProductItemRouteParamTypeProps;
  isInvalid?: boolean;
  orderIsRecused?: boolean;
}

export interface AddedProductResponsiveItemCoesProps
  extends Omit<AddedProductItemCoesProps, 'isInvalid'> {
  additionalInfoComponent: React.ReactNode;
  inputMoneyDataProps: InputMoneyProps;
  onRemoveProduct: () => void;
  inputIsDisabled: boolean;
}

export const AddedProductItemCoes: React.FC<AddedProductItemCoesProps> = ({
  data,
  type,
  isInvalid,
  orderIsRecused,
}) => {
  const {
    additionalInfoComponent,
    inputMoneyDataProps,
    onRemoveProduct,
    isLoadingAction,
    inputIsDisabled,
  } = useCoeAddedProductItem({
    data,
    type,
  });

  const lateralBarBackgroundColor = isInvalid
    ? 'feedback.attention.lightest'
    : 'product.estruturados';

  const params = {
    additionalInfoComponent,
    data,
    inputMoneyDataProps,
    onRemoveProduct,
    inputIsDisabled,
    type,
  };

  const layout = useBreakpointValue({
    base: <AddedProductItemCoesMobile {...params} />,
    sm: <AddedProductItemCoesTablet {...params} />,
    lg: <AddedProductItemCoesDesktop {...params} />,
  });

  if (isLoadingAction) {
    return <AddedProductItemCoesSkeleton />;
  }

  return (
    <AddedProductItemContainer
      data={data as AddedProductItemList}
      isInvalid={!!isInvalid}
      key={data.productId}
      orderIsRecused={!!orderIsRecused}
      lateralBarBackgroundColor={lateralBarBackgroundColor}>
      {layout}
    </AddedProductItemContainer>
  );
};
